import { Message } from '@twilio/conversations';

import { UnsentMessage } from '../../conversation-client/message-state/unsent-message';

export const isUnsentMessage = (message: Message | UnsentMessage): message is UnsentMessage => 'requestTime' in message;
